import { useCurrentStateAndParams } from "@uirouter/react";

import { translate } from "app/filters/i18nFilter";
import { PendingModelsBanner } from "app/pages/digital-marketing/generative-ai/llm-tracker/reports/components/banners/PendingModelsBanner";
import { ReportSectionTitle } from "app/pages/digital-marketing/generative-ai/llm-tracker/reports/components/ReportSectionTitle";
import { BrandOverviewComponent } from "app/pages/digital-marketing/generative-ai/llm-tracker/reports/overview-report/brand-overview/BrandOverviewComponent";
import { BrandsVisibilityComponent } from "app/pages/digital-marketing/generative-ai/llm-tracker/reports/overview-report/brands-visibility/BrandsVisibilityComponent";
import { CompetitiveInsightsWidget } from "app/pages/digital-marketing/generative-ai/llm-tracker/reports/overview-report/competitive-insights/CompetitiveInsightsWidget";
import { ModelComparisonComponent } from "app/pages/digital-marketing/generative-ai/llm-tracker/reports/overview-report/model-comparison/ModelComparisonComponent";
import { TopicsSummaryComponent } from "app/pages/digital-marketing/generative-ai/llm-tracker/reports/overview-report/topics-summary/TopicsSummaryComponent";
import { WhatChangedSection } from "app/pages/digital-marketing/generative-ai/llm-tracker/reports/overview-report/what-changed/WhatChangedSection";
import type { ILLMReport } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/types";

export const OverviewReport = (reportProps: ILLMReport) => {
    const {
        params: { model },
    } = useCurrentStateAndParams();

    const { campaign, campaignConfig, reportDuration } = reportProps;
    const isMultiPlatform = campaignConfig.configId.split(",").length >= 2;

    return (
        <>
            {isMultiPlatform ? <PendingModelsBanner campaign={campaign} /> : null}
            <ReportSectionTitle
                dataAutomationKey="overview-report-summary"
                title={translate("overview_report.summary.title")}
            />
            <BrandOverviewComponent {...reportProps} />
            <WhatChangedSection {...reportProps} />
            <ReportSectionTitle
                dataAutomationKey="overview-report-topics"
                title={translate("overview_report.topics.title")}
            />
            <TopicsSummaryComponent {...reportProps} />
            <ReportSectionTitle
                dataAutomationKey="verview-report-competitors"
                title={translate("overview_report.competitors.title")}
            />
            <CompetitiveInsightsWidget
                key={`${reportProps?.campaign?.id}-${JSON.stringify(reportDuration)}-${model}`}
                {...reportProps}
            />
            {isMultiPlatform ? (
                <ModelComparisonComponent {...reportProps} />
            ) : (
                <BrandsVisibilityComponent {...reportProps} />
            )}
        </>
    );
};
